import { Injectable } from '@angular/core';

type ConversionType = 'RegistrationComplete';

type Conversion = {
	readonly id: string;
	readonly converstionType: ConversionType;
};

declare const gtag: Function;

export const googleAdConversions: Record<ConversionType, Conversion> = {
	RegistrationComplete: {
		converstionType: 'RegistrationComplete',
		id: 'AW-990359679/3drcCLO7r8ABEP_gntgD'
	}
};

@Injectable({
	providedIn: 'root'
})
export class GoogleService {
	constructor() {}

	logConversion(conversion: Conversion): void {
		if (!gtag) {
			console.warn(`Google tag is not available`);
			return;
		}

		gtag('event', 'conversion', {
			send_to: conversion.id
		});
	}
}
